/* Xiaomi 2026 · Shell wrapper for all /xiaomi/* pages
 *
 * Loads the Fraunces + Manrope fonts on first mount (idempotent).
 * Applies the .xiaomi-theme palette via wrapping div.
 * Provides the sidebar nav layout the prototype uses.
 *
 * Usage in App.js:
 *   <Route path="/xiaomi" element={
 *     <ProtectedRoute>
 *       <XiaomiShell><XiaomiDashboard /></XiaomiShell>
 *     </ProtectedRoute>
 *   } />
 */
import React, { useEffect } from 'react';
import '../themes/xiaomi-theme.css';
import { ensureXiaomiFontsLoaded } from '../themes/xiaomi-fonts';
import XiaomiSidebar from '../components/xiaomi/XiaomiSidebar';

export default function XiaomiShell({ children }) {
  useEffect(() => {
    ensureXiaomiFontsLoaded();
  }, []);

  return (
    <div
      className="xiaomi-theme min-h-screen w-full"
      data-testid="xiaomi-shell"
    >
      <div className="flex">
        <XiaomiSidebar />
        <main className="flex-1 p-8 max-w-[1400px]">
          {children}
        </main>
      </div>
    </div>
  );
}
